import React from 'react';
/* eslint-disable react-hooks/exhaustive-deps */
import {
  ReportPaymentConnectorApollo,
  SalePaymentGetByTokenConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ThankYouContainer from './ThankYouContainer';
import { useEffect } from 'react';

interface IThankYouPage {
  pathPaymentMethods: string;
}

const ThankYouPage: React.FC<IThankYouPage> = ({ pathPaymentMethods }) => {
  const { token } = useParams();
  const {
    consts: { LANDING_URL },
  } = useAppContext();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  localStorage.removeItem('shoppingCartToken');

  if (!token) {
    window.location.href = String(LANDING_URL);
  }
  useEffect(() => {
    // If there is no payment authorization from Payu, navigate to payment methods page
    if (searchParams.get('error')) {
      navigate(pathPaymentMethods.replace(':token', String(token)));
    }
  }, []);

  const isPayuError = searchParams.get('error');
  useEffect(() => {
    // If there is no payment authorization from Payu, navigate to payment methods page
    if (isPayuError) {
      navigate(pathPaymentMethods.replace(':token', String(token)));
    }
  }, []);

  return token && !isPayuError ? (
    <ReportPaymentConnectorApollo>
      {({ reportPayment }: { reportPayment: any }) => (
        <SalePaymentGetByTokenConnectorApollo token={token} getPaymentMethods={false}>
          {({ ...paymentProduct }) => (
            <ThankYouContainer {...paymentProduct} reportPayment={reportPayment} token={token} />
          )}
        </SalePaymentGetByTokenConnectorApollo>
      )}
    </ReportPaymentConnectorApollo>
  ) : null;
};

export default ThankYouPage;
